// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    GetUnfilteredProducts,
    PopulateApiParameter,
    SendTracking,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { getIsPreviouslyPurchasedPage } from "@werner/App/Store/Selectors/GeneralSelectors";
import { xTrackSearchResultEvent } from "@werner/XDL/Utilities";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = {
        ...props.apiParameter,
        ...(props.parameter.additionalProps ?? {}),
        expand: (props.apiParameter.expand || []).concat("properties"),
    };

    // To show all products in Sub Categories
    const includeProductsInSubCategories = props.parameter?.["includeProductsInSubCategories"];
    // TOR-611: To get all attributes from Sub Categories
    const restrictAttributesToCategory = props.parameter?.["restrictAttributesToCategory"];

    if (props.apiParameter.categoryId) {
        props.apiParameter = {
            ...props.apiParameter,
            includeProductsInSubCategories,
            restrictAttributesToCategory,
        };
    }

    if (getIsPreviouslyPurchasedPage(props.getState())) {
        (props.apiParameter as any).previouslyPurchasedProducts = true;
    }
};

/** We should remove includeProductsInSubCategories from ApiParameter because this option need CategoryId
 * and GetUnfilteredProducts remove CategoryId from ApiParameter
 */

export const XngGetUnfilteredProducts: any = (props: any) => {
    if (!props.result.productFilters.pageCategoryId) {
        const apiParameter = { ...props.apiParameter };
        if (props.apiParameter.includeProductsInSubCategories) {
            delete apiParameter.includeProductsInSubCategories;
        }
        if (props.apiParameter.restrictAttributesToCategory) {
            delete apiParameter.restrictAttributesToCategory;
        }
        props.apiParameter = {
            ...apiParameter,
        };
    }
};

/**
 * WES-1699
 * Parse email to the dataLayer
 */
export const XngSendTracking: any = (props: any) => {
    const { search } = props.apiParameter;

    if (!search) {
        return;
    }

    const state = props.getState();
    const pagination = getProductListDataViewProperty(state, "pagination");
    const originalQuery = getProductListDataViewProperty(state, "originalQuery");
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    xTrackSearchResultEvent(
        originalQuery || "",
        pagination?.totalItemCount || 0,
        correctedQuery,
        props.parameter.userProfileId,
    );
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainBefore(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
replaceInChain(chain, SendTracking, XngSendTracking);
